export default __webpack_public_path__ + "static/media/thumb_wetland_wastewater.1c7fff9f.jpg";